import request from "../utils/http";
// 查询字典项列表
export function list(params) {
  return request({
    url: "/coupon/api/dictionary/item/" + params.dictCode,
    method: "GET",
    headers: {
      'Custom-Params': 'javaApi'
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/Dict.js